import Model, { attr } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';

export default class AggregateModel extends Model {
  declare [Type]: 'aggregate';
  @attr declare date: string; //YYYY
  @attr declare period_number: number;
  @attr declare period_type: 'day' | 'week' | 'month' | 'quarter' | 'year';

  @attr declare created_at: string;
  @attr declare updated_at: string;

  @attr declare value: number;
  @attr declare year: number; // MMMM
}
